export default __webpack_public_path__ + "static/media/404-error-page-not-found.44f968b5.jpg";